import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@app/services';

@Component({
  selector: 'app-logout',
  template: '<p>Logging Out...</p>',
})
export class LogoutComponent implements OnInit {
  constructor(
    private login: LoginService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Pass in returnTo options obj because this will usually get called by Single Sign Off and we don't want a series of redirects.
    this.login.logOut('/');
    localStorage.setItem('sso_logged_out', 'true');
  }
}
